module.exports = __webpack_public_path__ + "img/Balakrishnan_Prabhakaran@2x.79650cae.png";